import React, {useCallback, useEffect, useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
} from '@material-ui/core';
import { navLinks } from "./SeriesView";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import LeftBar from "../../components/left-bar/LeftBar";
import Content from "../../components/content/Content";
import ActionButton from "../../components/button/ActionButton";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import AnyField from "../../components/fields/AnyField";
import _ from "lodash";
import CheckboxField from "../../components/fields/CheckboxField";
import SelectFromItemsField from "../../components/fields/SelectFromItemsField";
import { parseTimeStringToDate, returnChangedFieldsEditSeries, returnChangedFieldsEditStep } from "../../utils/helpers";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DateField from "../../components/fields/DateField";
import { loadSerial } from "../../services/serial";
import { history } from "../../history";
import TimeField from "../../components/fields/TimeField";
import { parseXLS } from "../../services/common";
import { phonesXLSXRowsToDTOArray } from "../../services/whatsapp";
import UploadFilesField from "../../components/fields/UploadFilesField";
import { getAccessToken } from "../../services/baseReuqest";
import moment from "moment";
import Add from "@material-ui/icons/Add";
import Remove from "@material-ui/icons/Remove";
import { Pause, PlayArrow, Replay } from "@material-ui/icons";
import ShowField from "../../components/fields/ShowField";
import { Button, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles({
    container: {
        width: 700,
    },
    item: {
        padding: 5,
    },
    counter: {
        backgroundColor: "#DFDFDF",
        padding: "2px 8px",
        borderRadius: "6px",
        fontWeight: "500",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "-0.2px",
        marginLeft: "8px",
    },
    counterContainer: {
        color: "#757575",
        marginTop: "0.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    emptyLine: {
        height: "1px",
        width: "100%",
        backgroundColor: "#0000001F",
        marginTop: "2rem",
        marginBottom: "2rem",
    },
    verticalEmptyLine: {
        height: "100%",
        width: "1px",
        backgroundColor: "#0000001F",
        marginLeft: "40px",
        marginRight: "40px",
    },
    allSettings: {
        height: "12.5rem"
    },
    switcher: {
        display: "flex",
        width: "fit-content",
        marginBottom: "1rem",
        backgroundColor: "#F2F3F5",
        padding: "2px",
        borderRadius: "10px",
        gap: "2px",
        fontWeight: "500",
        letterSpacing: "-0.7px",
        fontSize: "15px",
        lineHeight: "20px",
        color: "#000000",
    },
    activeBtn: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        border: " 0.5px solid #00000014",
        borderBottom: "none",
        padding: "7px 47px",
        cursor: "pointer",
        boxShadow: "0px 3px 1px 0px #0000000A",

},
    inactiveBtn: {
        padding: "7px 47px",
        cursor: "pointer",
        border: "none"
    },
    fileName: {
        margin: "10px 0",
    },
    actions: {
        display: "flex",
        alignItems: "flex-end",
        gap: "10px",
        marginTop: "2rem",
        width: "100%"
    },
    deleteBtn: {
        backgroundColor: "#FFC107",
        border: "none",
        padding: "10px",
        fontWeight: "bold",
        cursor: "pointer",
    },
    downloadBtn: {
        fontFamily: "Roboto",
        border: "1px solid #A21F99",
        color: "#7b1fa2",
        backgroundColor: "#fff",
        fontSize: "0.8125rem",
        padding: "8px 22px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        marginTop: "0",
        height: "40px",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
    },
    topRightButton: {
        marginTop: "-35px",
        backgroundColor: "#34B41F",
        borderRadius: "4px",
        padding: "14px 31px",
        height: "48px",
        color: "#ffffff",

        "&:hover": {
            backgroundColor: "#2E9F1B",
            color: "#ffffff",
        },
    },
    topRightButtonPause: {
        marginTop: "-35px",
        backgroundColor: "#B48C1F",
        borderRadius: "4px",
        padding: "14px 31px",
        height: "48px",
        color: "#ffffff",

        "&:hover": {
            backgroundColor: "#FFC107",
            color: "#ffffff",
        },
    },
    settingsTitle: {
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "0.5rem",
        color: "#000000DE",
    },
    stepBtn: {
        padding: "8px 24px",
        color: "#A21F99",
        fontWeight: "500",
        lineHeight: "24px",
        fontSize: "16px",
        backgroundColor: "transparent",
        border: "1px solid #FFC107",
        borderRight: "none",
        cursor: "pointer",
        outline: "none",
    },
    activeStepBtn: {
        padding: "8px 24px",
        color: "#A21F99",
        fontWeight: "500",
        lineHeight: "24px",
        fontSize: "16px",
        backgroundColor: "#FFC107",
        border: "1px solid #FFC107",
        borderRight: "none",
        cursor: "pointer",
        outline: "none",
    },
    firstStepBtn: {
        borderTopLeftRadius: "12px",
        borderBottomLeftRadius: "12px",
    },

    lastStepBtn: {
        borderTopRightRadius: "12px",
        borderBottomRightRadius: "12px",
        borderRight: "1px solid #FFC107",
    },
    addStepBtn: {
        display: "inline-flex",
        gap: "8px",
        padding: "8px 24px",
        color: "#A21F99",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        backgroundColor: "transparent",
        border: "1px solid #A21F99",
        borderRadius: "10px",
        cursor: "pointer",
        outline: "none",
        marginLeft: "16px",

        "&:disabled": {
            backgroundColor: "#F4F4F4",
            color: "#C0C0C0",
            border: "1px solid #C0C0C0",
            cursor: "not-allowed",
        },
    },
    amountStep: {
        display: "flex",
        alignItems: "flex-start",
    },
    amountStepLabel: {
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "14px",
        color: "#0000008A",
        marginTop: "8px"
    },
    dialogContainer: {
        minWidth: "579px",
        maxWidth: "579px",
        padding: "24px 8px"
    },
    emptyLineDialog: {
        width: "515px",
        height: "1px",
        backgroundColor: "#0000001F",
        margin: "8px auto"
    },
    deleteButton: {
        backgroundColor: "#FF2F1C",
        color: "#FFFFFF",
        padding: "8px 10px",

        "&:disabled": {
            backgroundColor: "#F4F4F4",
            color: "#C0C0C0",
            border: "1px solid #C0C0C0",
            cursor: "not-allowed",
        },
    },
    titleStatusStep: {
        fontFamily: "Roboto",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "32px",
        letterSpacing: "0.15px",
        marginBottom: "32px",
        color: "#939393DE",
    }
});

const emptySerial = {
    seriesId: null,
    name: '',
    seriesStatus: 'ready',
    actualStep: 0,
    dateStart: null,
    timeOfStartSending: '',
    timeOfEndSending: '',
    timeZone: '',
    createdAt: null,
    creator: '',
    seriesExecutorParam: '',
    phoneNumbers: [],
    isWarmingUpSeries: false,
    seriesSteps: [
        {
            seriesStepId: null,
            stepNumber: 1,
            stepStatus: 'new',
            moveSendingToNextDay: false,
            textMessage: '',
            transports: [],
            transportType: [],
            ignoreSentMessagesToGuest: false,
            amountOfDaysForShift: 1,
            amountOfSeriesActionsForHandle: 0,
            amountOfHandledSeriesActions: 0,
            seriesStepExecutorParam: '',
            seriesImagePathForFrontend: null,
            plannedStartDate: null,
        }
    ]
};

const emptyStep = {
    stepId: null,
    amountOfDaysForShift: 1,
    textMessage: "",
    transportIds: [],
    ignoreSentMessagesToGuest: false,
    seriesId: "",
    stepNumber: 1,
    moveSendingToNextDay: false,
    executorParam: [],
    seriesImagePathForFrontend: null,
    plannedStartDate: null,
    fileNameForFrontend: null,
};

const stepStatusTranslations = {
    "new": "Новый",
    "ready": "Готов",
    "active": "В работе",
    "paused": "На паузе",
    "stopped": "Остановлен",
    "finished": "Завершен",
};

const isGreenApiTransportType = (value) => (value || '').toLowerCase().replace(/\s+/g, '') === 'greenapi';

const EditSerialPage = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { id, view, edit } = useParams();

    const [serial, setSerial] = useState({ ...emptySerial });
    const [step, setStep] = useState({...emptyStep})
    const [serialOriginalData, setSerialOriginalData] = useState({ ...emptySerial });
    const [editing, setEditing] = useState(!view && !!edit);
    const [editingStep, setEditingStep] = useState(false);
    // const [editStep, setEditStep] = useState(false);
    const [notFound, setNotFound] = useState(false);
    // const [importFileName, setImportFileName] = useState(null);
    const [importError, setImportError] = useState(null);
    const [error, setError] = useState(false);
    const [image, setImage] = useState(null);
    const [switcher, setSwitcher] = useState(false)
    const [mailingList, setMailingList] = useState([]);
    const [executorsList, setExecutorsList] = useState([]);
    const [executorsListForSteps, setExecutorsListForSteps] = useState([]);
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [isFirstStepSaved, setIsFirstStepSaved] = useState(false);
    const [alarmMessage, setAlarmMessage] = useState(false);
    const [disableRequest, setDisableRequest] = useState(false)

    const [deleteStepDialog, setDeleteStepDialog] = useState(false);
    const [stopSeriesDialog, setStopSeriesDialog] = useState(false);
    const [deleteSeriesDialog, setDeleteSeriesDialog] = useState(false);
    const [isDuplicated, setIsDuplicated] = useState(false);
    const [isDisabledNewStep, setIsDisabledNewStep] = useState(false);
    const [transportTypes, setTransportTypes] = useState([]);
    const [transportChannelsMap, setTransportChannelsMap] = useState({});
    const [selectedTransportType, setSelectedTransportType] = useState('');
    const activeChannels = (selectedTransportType && transportChannelsMap[selectedTransportType])
        ? transportChannelsMap[selectedTransportType].map(i => ({ id: i.id, name: i.name }))
        : [];

    const savedChannels = (step?.transportIds || []).map(i => ({ id: i.id, name: i.name }));
    const buildStepFromSeries = (seriesStep, seriesId) => ({
        stepId: seriesStep.seriesStepId,
        amountOfDaysForShift: seriesStep.amountOfDaysForShift,
        textMessage: seriesStep.textMessage,
        transportIds: seriesStep.transports,
        ignoreSentMessagesToGuest: seriesStep.ignoreSentMessagesToGuest,
        seriesId,
        stepNumber: seriesStep.stepNumber,
        moveSendingToNextDay: seriesStep.moveSendingToNextDay,
        executorParam: seriesStep.seriesStepExecutorParam,
        seriesImagePathForFrontend: seriesStep.seriesImagePathForFrontend,
        plannedStartDate: seriesStep.plannedStartDate,
        fileNameForFrontend: seriesStep.fileNameForFrontend
    });

    let itemsForSelect;
    if (!editing) {
        itemsForSelect = savedChannels;
    } else {
        itemsForSelect = activeChannels;
    }

    const [fileName, setFileName] = useState("");

    const utcList = [
        { text: "00:00", value: "+00:00" },
        { text: "+01:00", value: "+01:00" },
        { text: "+02:00", value: "+02:00" },
        { text: "+03:00", value: "+03:00" },
        { text: "+03:30", value: "+03:30" },
        { text: "+04:00", value: "+04:00" },
        { text: "+04:30", value: "+04:30" },
        { text: "+05:00", value: "+05:00" },
        { text: "+05:30", value: "+05:30" },
        { text: "+05:45", value: "+05:45" },
        { text: "+06:00", value: "+06:00" },
        { text: "+06:30", value: "+06:30" },
        { text: "+07:00", value: "+07:00" },
        { text: "+08:00", value: "+08:00" },
        { text: "+08:45", value: "+08:45" },
        { text: "+09:00", value: "+09:00" },
        { text: "+09:30", value: "+09:30" },
        { text: "+10:00", value: "+10:00" },
        { text: "+10:30", value: "+10:30" },
        { text: "+11:00", value: "+11:00" },
        { text: "+12:00", value: "+12:00" },
        { text: "+12:45", value: "+12:45" },
        { text: "+13:00", value: "+13:00" },
        { text: "+14:00", value: "+14:00" },
    ];

    useEffect(() => {
        if (id !== "0") {
            loadSerial(id).then((response) => {
                if (response && response.series && response.series.length > 0) {
                    const data = _.clone(response.series[0]);

                    const updated = {
                        ...emptySerial,

                        seriesId: data.seriesId || null,
                        name: data.name || '',
                        seriesStatus: data.seriesStatus || '',
                        actualStep: data.actualStep || 0,
                        dateStart: data.dateStart || null,
                        timeOfStartSending: data.timeOfStartSending || '',
                        timeOfEndSending: data.timeOfEndSending || '',
                        timeZone: data.timeZone || '',
                        createdAt: data.createdAt || null,
                        creator: data.creator || '',
                        seriesExecutorParam: data.seriesExecutorParam || '',
                        isWarmingUpSeries: data.isWarmingUpSeries || false,

                        seriesSteps: Array.isArray(data.seriesSteps) && data.seriesSteps.length
                            ? data.seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber).map((step) => ({
                                seriesStepId: step.seriesStepId || null,
                                stepNumber: step.stepNumber || 1,
                                stepStatus: step.stepStatus || '',
                                moveSendingToNextDay: step.moveSendingToNextDay || false,
                                textMessage: step.textMessage || '',
                                transports: step.transports || [],
                                transportType: step.transportType || '',
                                ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest || false,
                                amountOfDaysForShift: step.amountOfDaysForShift || 1,
                                amountOfSeriesActionsForHandle: step.amountOfSeriesActionsForHandle || 0,
                                amountOfHandledSeriesActions: step.amountOfHandledSeriesActions || 0,
                                seriesStepExecutorParam: step.seriesStepExecutorParam || '',
                                seriesImagePathForFrontend: step.seriesImagePathForFrontend || null,
                                plannedStartDate: step.plannedStartDate || null,
                                fileNameForFrontend: step.fileNameForFrontend || null,
                            }))
                            : [
                                {
                                    seriesStepId: null,
                                    stepNumber: 1,
                                    stepStatus: '',
                                    moveSendingToNextDay: false,
                                    textMessage: '',
                                    transports: [],
                                    transportType: '',
                                    ignoreSentMessagesToGuest: false,
                                    amountOfDaysForShift: 1,
                                    amountOfSeriesActionsForHandle: 0,
                                    amountOfHandledSeriesActions: 0,
                                    seriesStepExecutorParam: '',
                                    seriesImagePathForFrontend: null,
                                    plannedStartDate: null,
                                    fileNameForFrontend: null,
                                }
                            ],
                    };

                    if (updated?.seriesSteps[0]?.seriesStepId !== null) {
                        setIsFirstStepSaved(true);
                    }

                    setSerial(updated);
                    setSerialOriginalData(updated);
                    setStep({
                        stepId: updated.seriesSteps[0].seriesStepId,
                        amountOfDaysForShift: updated.seriesSteps[0].amountOfDaysForShift,
                        textMessage: updated.seriesSteps[0].textMessage,
                        transportIds: updated.seriesSteps[0].transports,
                        transportType: updated.seriesSteps[0].transportType || '',
                        ignoreSentMessagesToGuest: updated.seriesSteps[0].ignoreSentMessagesToGuest,
                        seriesId: updated.seriesId,
                        stepNumber: updated.seriesSteps[0].stepNumber,
                        moveSendingToNextDay: updated.seriesSteps[0].moveSendingToNextDay,
                        executorParam: updated.seriesSteps[0].seriesStepExecutorParam,
                        seriesImagePathForFrontend: updated.seriesSteps[0].seriesImagePathForFrontend,
                        plannedStartDate: updated.seriesSteps[0].plannedStartDate,
                        fileNameForFrontend: updated.seriesSteps[0].fileNameForFrontend
                    })
                    setFileName(updated.seriesSteps[0].fileNameForFrontend)

                } else {
                    setNotFound(true);
                }
            });
        }
        getAllTransport();
        getExecutors();
    }, [id]);

    const getExecutors = () => {
        fetch('/api/erp/get-series-executor', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then(res => {
            return res.json()
        }).then(data => {
            if (data.success !== 0) {
                setExecutorsList(data.executorsForSeries.map(i => {
                    return {
                        ...i,
                        text: i.comment,
                        value: i.name
                    }
                }))
                setExecutorsListForSteps(data.executorsForSeriesSteps.map(i => {
                    return {
                        ...i,
                        text: i.comment,
                        value: i.name
                    }
                }))
            }
        })
    }

    const getAllTransport = () => {
        fetch('/api/transport/all-active', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then(res => {
            return res.json();
        }).then(data => {
            if (data?.transports) {
                if (Array.isArray(data.transports)) {
                    setMailingList(data.transports.map(val => ({ ...val, text: val.name, value: val.id })));
                    setTransportTypes([]);
                    setTransportChannelsMap({});
                    setSelectedTransportType('');
                } else if (typeof data.transports === 'object') {
                    const types = Object.keys(data.transports).map(key => ({ value: key, text: key }));
                    const map = {};
                    const flattened = [];
                    Object.entries(data.transports).forEach(([key, arr]) => {
                        map[key] = (arr || []).map(ch => ({ id: ch.id, name: ch.name, amountOfLetters: ch.amountOfLetters }));
                        (arr || []).forEach(ch => {
                            flattened.push({ id: ch.id, name: ch.name, text: ch.name, value: ch.id });
                        });
                    });
                    setTransportTypes(types);
                    setTransportChannelsMap(map);
                    setMailingList(flattened);
                    setSelectedTransportType(prev =>
                        prev ? prev : (types.length ? types[0].value : '')
                    );
                }
            }
        })
    }

    useEffect(() => {
        if (step?.transportType) {
            setSelectedTransportType(step.transportType);
        }
    }, [step.transportType]);

    const findTransportTypeByChannelId = useCallback((channelId) => {
        if (!channelId) return null;
        for (const [type, channels] of Object.entries(transportChannelsMap || {})) {
            if ((channels || []).some(ch => ch.id === channelId)) return type;
        }
        return null;
    }, [transportChannelsMap]);

    const getMessageLimit = () => {
        if (!selectedTransportType) return null;
        if (selectedTransportType !== 'megafon') return null;
        const channels = transportChannelsMap[selectedTransportType] || [];
        const selectedIds = (step.transportIds || []).map(i => (typeof i === 'object' ? i.id : i));
        const source = selectedIds.length ? channels.filter(ch => selectedIds.includes(ch.id)) : channels;
        const nums = source.map(ch => Number(ch.amountOfLetters)).filter(n => !isNaN(n) && n > 0);
        if (!nums.length) return null;
        return Math.min(...nums);
    };

    useEffect(() => {
        if (!transportTypes.length) return;
        const ids = (step.transportIds || []).map(i => (typeof i === 'object' ? i.id : i));
        if (!ids.length) return;
        const found = findTransportTypeByChannelId(ids[0]);
        if (found) setSelectedTransportType(found);
    }, [step.transportIds, findTransportTypeByChannelId, transportTypes.length]);

    const isCreatingFirstStep = currentStepIndex === 0 && (isDuplicated || !(step && step.stepId));

    useEffect(() => {
        if (!editing || !isCreatingFirstStep) return;
        if (selectedTransportType && !isGreenApiTransportType(selectedTransportType) && serial.isWarmingUpSeries) {
            setSerial(prev => ({ ...prev, isWarmingUpSeries: false }));
        }
    }, [editing, isCreatingFirstStep, selectedTransportType, serial.isWarmingUpSeries]);

    useEffect(() => {
        if (!editing || !serial.isWarmingUpSeries || isCreatingFirstStep) return;
        if (selectedTransportType && !isGreenApiTransportType(selectedTransportType)) {
            const greenApiType = transportTypes.find(item => isGreenApiTransportType(item.value));

            if (greenApiType) {
                setSelectedTransportType(greenApiType.value);
                setStep(prev => ({ ...prev, transportIds: [] }));
            }
        }
    }, [editing, serial.isWarmingUpSeries, isCreatingFirstStep, selectedTransportType, transportTypes]);

    const isStepLocked = () => {
        return (((!editing || (!editingStep && id !== '0')) && (serial?.seriesSteps?.[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0));
    }

    const toTodayMoment = (timeStr) => {
        return moment(timeStr, "HH:mm")
            .local()
            .year(moment().year())
            .month(moment().month())
            .date(moment().date())
            .second(0)
            .millisecond(0);
    };

    const translateStepStatus = (status) => {
        if (!status) return "";
        return stepStatusTranslations[status] || status;
    }

    const saveSerial = async () => {
        const dataToSend = {
            name: serial.name.trim(),
            dateStart: serial.dateStart,
            timeOfStartSending: serial.timeOfStartSending,
            timeOfEndSending: serial.timeOfEndSending,
            timeZone: serial.timeZone,
            executorParam: serial.seriesExecutorParam.length ? serial.seriesExecutorParam : null,
            isWarmingUpSeries: serial.isWarmingUpSeries,
        }

        if (!step.textMessage.length) {
            setImportError("Необходимо заполнить поле 'Текст сообщения'");
            setError(true);
            return
        }

        if (!serial.name.length) {
            setImportError("Необходимо заполнить поле 'Название серии'");
            setError(true);
            return
        }

        if (!serial.dateStart) {
            setImportError("Необходимо заполнить поле 'Дата'");
            setError(true);
            return
        }

        const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        if (!serial.timeOfStartSending || !timeRegex.test(serial.timeOfStartSending)) {
            setImportError("Необходимо заполнить поле 'Начало'");
            setError(true);
            return;
        }

        if (!serial.timeOfEndSending || !timeRegex.test(serial.timeOfEndSending)) {
            setImportError("Необходимо заполнить поле 'Завершение'");
            setError(true);
            return
        }

        if (!serial.timeZone.length) {
            setImportError("Необходимо заполнить поле 'Часовой пояс'");
            setError(true);
            return
        }

        const start = toTodayMoment(serial.timeOfStartSending);
        const end = toTodayMoment(serial.timeOfEndSending);

        if (end.isBefore(start, "minute")) {
            setImportError("Необходимо корректно заполнить поля 'Начало' и 'Завершение'");
            setError(true);
            setDisableRequest(false);
            return;
        }

        setEditingStep(false);
        setCurrentStepIndex(0);
        handleStep(0);

        setDisableRequest(true);

        const response = await fetch(`/api/series/${serial.seriesId}/edit`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            },
            body: JSON.stringify(returnChangedFieldsEditSeries(dataToSend, serialOriginalData)),
        });
        let result = await response.json();

        if (result?.success === 0) {
            setImportError(result.message);
            setError(true);
            setDisableRequest(false);

            return
        }

        result.series[0].seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber);

        if (result.series.length) {
            setIsFirstStepSaved(true);
            setSerial(result.series[0]);
            setSerialOriginalData(result.series[0]);
            if (result.series[0]?.seriesSteps[currentStepIndex]) {
                setStep({
                    stepId: result.series[0].seriesSteps[currentStepIndex].seriesStepId,
                    amountOfDaysForShift: result.series[0].seriesSteps[currentStepIndex].amountOfDaysForShift,
                    textMessage: result.series[0].seriesSteps[currentStepIndex].textMessage,
                    transportIds: result.series[0].seriesSteps[currentStepIndex].transports,
                    ignoreSentMessagesToGuest: result.series[0].seriesSteps[currentStepIndex].ignoreSentMessagesToGuest,
                    seriesId: result.series[0].seriesId,
                    stepNumber: result.series[0].seriesSteps[currentStepIndex].stepNumber,
                    moveSendingToNextDay: result.series[0].seriesSteps[currentStepIndex].moveSendingToNextDay,
                    executorParam: result.series[0].seriesSteps[currentStepIndex].seriesStepExecutorParam,
                    seriesImagePathForFrontend: result.series[0].seriesSteps[currentStepIndex].seriesImagePathForFrontend,
                    plannedStartDate: result.series[0].seriesSteps[currentStepIndex].plannedStartDate,
                    fileNameForFrontend: result.series[0].seriesSteps[currentStepIndex].fileNameForFrontend,
                })
            }
            setEditing(false)
            setDisableRequest(false)
        }
        // try {
        //
        // } catch (error) {
        //     // setImportError('Произошла ошибка при сохранении шага');
        //     setDisableRequest(false);
        //     setError(true)
        //     console.error(error);
        // } finally {
        //     setDisableRequest(false);
        // }
    }

    const createDuplicateSeries = async () => {
        handleStep(0)
        setEditing(true);
        setIsDuplicated(true);
        setSerial(prev => ({
            ...prev,
            phoneNumbers: [],
            seriesSteps: prev.seriesSteps.map((item) => ({
                ...item,
                amountOfSeriesActionsForHandle: 0,
                amountOfHandledSeriesActions: 0,
                seriesImagePathForFrontend: null
            }))
        }));
        setCurrentStepIndex(0);

        setStep(buildStepFromSeries(
            serial.seriesSteps[0],
            serial.seriesId
        ));

        history.push('/series/edit/0');
    }

    const createStep = async () => {
        if (!editingStep) {
            if (isDuplicated) {
                setCurrentStepIndex(0)
                const validIds = new Set(mailingList.map(m => m.value))

                const cleanedTransportIds = step.transportIds
                    .map(t => (typeof t === "object" && t !== null ? t.id : t))
                    .filter(id => validIds.has(id) || step.transportIds?.length === 1);

                const formData = new FormData();
                const dataToSend = {
                    name: serial.name.trim(),
                    dateStart: serial.dateStart,
                    timeOfStartSending: serial.timeOfStartSending,
                    timeOfEndSending: serial.timeOfEndSending,
                    timeZone: serial.timeZone,
                    seriesStep: {
                        textMessage: step.textMessage,
                        transportIds: cleanedTransportIds,
                        ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest,
                        moveSendingToNextDay: step.moveSendingToNextDay
                    },
                    phoneNumbers: serial.phoneNumbers ?? [],
                    executorParam: serial.seriesExecutorParam ?? '',
                    isWarmingUpSeries: serial.isWarmingUpSeries,
                }

                delete dataToSend.seriesExecutorParam;
                formData.append("data", JSON.stringify(dataToSend));

                if (image) {
                    formData.append("file", image);
                }

                if (!step.textMessage.length) {
                    setImportError("Необходимо заполнить поле 'Текст сообщения'");
                    setError(true);
                    return
                }

                if (!serial.name.length) {
                    setImportError("Необходимо заполнить поле 'Название серии'");
                    setError(true);
                    return
                }

                if (!serial.dateStart) {
                    setImportError("Необходимо заполнить поле 'Дата'");
                    setError(true);
                    return
                }

                const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
                if (!serial.timeOfStartSending || !timeRegex.test(serial.timeOfStartSending)) {
                    setImportError("Необходимо заполнить поле 'Начало'");
                    setError(true);
                    return;
                }

                if (!serial.timeOfEndSending || !timeRegex.test(serial.timeOfEndSending)) {
                    setImportError("Необходимо заполнить поле 'Завершение'");
                    setError(true);
                    return
                }

                if (!serial.timeZone.length) {
                    setImportError("Необходимо заполнить поле 'Часовой пояс'");
                    setError(true);
                    return
                }

                if (!serial.phoneNumbers.length && !serial.seriesExecutorParam.length) {
                    setImportError("Необходимо загрузить базу или выбрать экзекутора");
                    setError(true);
                    return
                }

                const start = toTodayMoment(serial.timeOfStartSending);
                const end = toTodayMoment(serial.timeOfEndSending);

                if (end.isBefore(start, "minute")) {
                    setImportError("Необходимо корректно заполнить поля 'Начало' и 'Завершение'");
                    setError(true);
                    setDisableRequest(false);
                    return;
                }

                setDisableRequest(true);

                const response = await fetch('/api/series/create', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${getAccessToken()}`,
                    },
                    body: formData,
                });
                const result = await response.json();

                if (result.success === 0) {
                    setImportError(result.message);
                    setError(true);
                    setDisableRequest(false);

                    return
                }

                if (result.success === false) {
                    if (result.message) setImportError(result.message);
                    else setImportError(result.error.message);
                    setError(true);
                    setDisableRequest(false);

                    return
                }

                if (result.series.length) {
                    setIsFirstStepSaved(true);

                    if (serial.seriesSteps.length > 1) {
                        for (let i = 1; i < serial.seriesSteps.length; i++) {
                            const step = serial.seriesSteps[i];

                            const formDataStep = new FormData();

                            const validIds = new Set(mailingList.map(m => m.value));

                            const cleanedTransportIds = step.transports
                                .map(t => (typeof t === 'object' && t !== null ? t.id : t))
                                .filter(id => validIds.has(id) || step.transports.length === 1);

                            const updateStepToSend = {
                                amountOfDaysForShift: step.amountOfDaysForShift,
                                textMessage: step.textMessage,
                                transportIds: cleanedTransportIds,
                                ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest,
                                seriesId: result.series[0].seriesId,
                                stepNumber: step.stepNumber,
                                moveSendingToNextDay: step.moveSendingToNextDay,
                                executorParam: serial.seriesSteps[i].seriesStepExecutorParam && serial.seriesSteps[i].seriesStepExecutorParam.length ? serial.seriesSteps[i].seriesStepExecutorParam : null
                            };

                            formDataStep.append('data', JSON.stringify(updateStepToSend));

                            if (step.image) {
                                formDataStep.append('file', step.image);
                            }

                            const stepResponse = await fetch(`/api/series-step/${result.series[0].seriesId}/create`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${getAccessToken()}`,
                                },
                                body: formDataStep,
                            });

                            const stepResult = await stepResponse.json();

                            if (stepResult.success === 0) {
                                setImportError(stepResult.message);
                                setError(true);
                                setDisableRequest(false);
                                return;
                            }

                            if (stepResult.seriesSteps) {
                                setSerial(prev => ({
                                    ...prev,
                                    seriesSteps: stepResult.seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber)
                                }));
                                setSerialOriginalData(prev => ({
                                    ...prev,
                                    seriesSteps: stepResult.seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber)
                                }));
                            }
                        }
                    }

                    setSerial(result.series[0]);
                    setSerialOriginalData(result.series[0]);
                }

                setEditing(false);
                setEditingStep(false);
                setDisableRequest(false);
                setIsDuplicated(false);

                history.push(`/series/view/${result.series[0].seriesId}`);
                return
            }

            if (currentStepIndex === 0 && !isFirstStepSaved) {

                const validIds = new Set(mailingList.map(m => m.value))

                const cleanedTransportIds = step.transportIds
                    .map(t => {
                        return (typeof t === "object" && t !== null ? t.id : t)
                    })
                    .filter(id => validIds.has(id) || step.transportIds.length === 1)

                const formData = new FormData();
                const dataToSend = {
                    name: serial.name.trim(),
                    dateStart: serial.dateStart,
                    timeOfStartSending: serial.timeOfStartSending,
                    timeOfEndSending: serial.timeOfEndSending,
                    timeZone: serial.timeZone,
                    seriesStep: {
                        textMessage: step.textMessage,
                        transportIds: cleanedTransportIds,
                        ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest,
                        moveSendingToNextDay: step.moveSendingToNextDay
                    },
                    phoneNumbers: serial.phoneNumbers ?? [],
                    executorParam: serial.seriesExecutorParam ?? '',
                    isWarmingUpSeries: serial.isWarmingUpSeries,
                }

                delete dataToSend.seriesExecutorParam;
                formData.append("data", JSON.stringify(dataToSend));

                if (image) {
                    formData.append("file", image);
                }

                if (!step.textMessage.length) {
                    setImportError("Необходимо заполнить поле 'Текст сообщения'");
                    setError(true);
                    return
                }

                if (!serial.name.length) {
                    setImportError("Необходимо заполнить поле 'Название серии'");
                    setError(true);
                    return
                }

                if (!serial.dateStart) {
                    setImportError("Необходимо заполнить поле 'Дата'");
                    setError(true);
                    return
                }

                const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
                if (!serial.timeOfStartSending || !timeRegex.test(serial.timeOfStartSending)) {
                    setImportError("Необходимо заполнить поле 'Начало'");
                    setError(true);
                    return;
                }

                if (!serial.timeOfEndSending || !timeRegex.test(serial.timeOfEndSending)) {
                    setImportError("Необходимо заполнить поле 'Завершение'");
                    setError(true);
                    return
                }

                if (!serial.timeZone.length) {
                    setImportError("Необходимо заполнить поле 'Часовой пояс'");
                    setError(true);
                    return
                }

                if (!serial.phoneNumbers.length && !serial.seriesExecutorParam.length) {
                    setImportError("Необходимо загрузить базу или выбрать экзекутора");
                    setError(true);
                    return
                }

                const start = toTodayMoment(serial.timeOfStartSending);
                const end = toTodayMoment(serial.timeOfEndSending);

                if (end.isBefore(start, "minute")) {
                    setImportError("Необходимо корректно заполнить поля 'Начало' и 'Завершение'");
                    setError(true);
                    setDisableRequest(false);
                    return;
                }

                setDisableRequest(true);

                const response = await fetch('/api/series/create', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${getAccessToken()}`,
                    },
                    body: formData,
                });
                const result = await response.json();

                if (result.success === 0) {
                    setImportError(result.message);
                    setError(true);
                    setDisableRequest(false);

                    return
                }

                if (result.success === false) {
                    if (result.message) setImportError(result.message);
                    else setImportError(result.error.message);
                    setError(true);
                    setDisableRequest(false);

                    return
                }

                if (result.series.length) {
                    setIsFirstStepSaved(true);
                    setSerial(result.series[0]);
                    setSerialOriginalData(result.series[0])
                }

                setDisableRequest(false);

                history.push(`/series/view/${result.series[0].seriesId}`);
            } else {
                const formData = new FormData();

                const validIds = new Set(mailingList.map(m => m.value))

                const cleanedTransportIds = step.transportIds
                    .map(t => {
                        return (typeof t === "object" && t !== null ? t.id : t)
                    })
                    .filter(id => validIds.has(id) || step.transportIds.length === 1)

                const updateStepToSend = {
                    amountOfDaysForShift: step.amountOfDaysForShift,
                    textMessage: step.textMessage,
                    transportIds: cleanedTransportIds,
                    ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest,
                    seriesId: serial.seriesId,
                    stepNumber: currentStepIndex + 1,
                    moveSendingToNextDay: step.moveSendingToNextDay,
                    executorParam: Array.isArray(step.executorParam) ? step.executorParam : []
                };

                formData.append("data", JSON.stringify(updateStepToSend));

                if (image) {
                    formData.append("file", image);
                }

                if (!step.textMessage.length) {
                    setImportError("Необходимо заполнить поле 'Текст сообщения'");
                    setError(true);
                    return
                }

                setDisableRequest(true);

                const response = await fetch(`/api/series-step/${serial.seriesId}/create`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${getAccessToken()}`,
                    },
                    body: formData,
                });
                const result = await response.json();

                if (result.success === 0) {
                    setImportError(result.message);
                    setError(true);
                    setDisableRequest(false);

                    return
                }

                if (result.seriesSteps) {
                    setSerial(prev => ({
                        ...serialOriginalData,
                        seriesSteps: result.seriesSteps.sort((a, b) => {
                            return a.stepNumber - b.stepNumber
                        })
                    }));

                    setSerialOriginalData(prev => ({
                        ...prev,
                        seriesSteps: result.seriesSteps.sort((a, b) => {
                            return a.stepNumber - b.stepNumber
                        })
                    }));

                    setStep({
                        stepId: result.seriesSteps[currentStepIndex].seriesStepId,
                        amountOfDaysForShift: result.seriesSteps[currentStepIndex].amountOfDaysForShift,
                        textMessage: result.seriesSteps[currentStepIndex].textMessage,
                        transportIds: result.seriesSteps[currentStepIndex].transports,
                        ignoreSentMessagesToGuest: result.seriesSteps[currentStepIndex].ignoreSentMessagesToGuest,
                        seriesId: result.seriesId,
                        stepNumber: currentStepIndex,
                        moveSendingToNextDay: result.seriesSteps[currentStepIndex].moveSendingToNextDay,
                        executorParam: result.seriesSteps[currentStepIndex].seriesStepExecutorParam,
                        seriesImagePathForFrontend: result.seriesSteps[currentStepIndex].seriesImagePathForFrontend,
                        plannedStartDate: result.seriesSteps[currentStepIndex].plannedStartDate,
                        fileNameForFrontend: result.seriesSteps[currentStepIndex].fileNameForFrontend
                    });
                    setFileName(result.seriesSteps[currentStepIndex].fileNameForFrontend)
                    setImage(null)
                }
            }
            setDisableRequest(false);
            setEditingStep(false);
            setIsDisabledNewStep(false);
            setIsDisabledNewStep(false);
        } else {
            if (typeof step.executorParam === "string" || !step.executorParam) {
                step.executorParam = []
            }

            const formData = new FormData();

            const validIds = new Set(mailingList.map(m => m.value))

            const cleanedTransportIds = step.transportIds
                .map(t => (typeof t === "object" && t !== null ? t.id : t))
                .filter(id => validIds.has(id) || step.transportIds.length === 1)

            const validExecutors = new Set(executorsListForSteps.map(i => i.name))
            const cleanedExecutorParams = step.executorParam.filter(e => validExecutors.has(e) || step.executorParam.length === 1)

            const updateStepToSend = {
                amountOfDaysForShift: currentStepIndex === 0 ? 0 : step.amountOfDaysForShift,
                textMessage: step.textMessage,
                transportIds: cleanedTransportIds,
                ignoreSentMessagesToGuest: step.ignoreSentMessagesToGuest,
                seriesId: serial.seriesId,
                stepNumber: currentStepIndex + 1,
                moveSendingToNextDay: step.moveSendingToNextDay,
                executorParam: cleanedExecutorParams
            };

            formData.append("data", JSON.stringify(returnChangedFieldsEditStep(updateStepToSend, serial.seriesSteps[currentStepIndex])));

            if (image) {
                formData.append("file", image);
            }

            if (!step.textMessage.length) {
                setImportError("Необходимо заполнить поле 'Текст сообщения'");
                setError(true);
            }

            setDisableRequest(true);

            const response = await fetch(`/api/series-step/${step.stepId}/edit`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`,
                },
                body: formData,
            });

            const result = await response.json();

            if (result.success === 0) {
                setImportError(result.message);
                setDisableRequest(false);
                setError(true);

                return
            }

            if (result.success === false) {
                setImportError('Произошла ошибка при сохранении шага');
                setDisableRequest(false);
                setError(true);

                return
            }

            if (result.seriesSteps) {
                setSerial(prev => ({
                    ...serialOriginalData,
                    seriesSteps: result.seriesSteps.sort((a, b) => {
                        return a.stepNumber - b.stepNumber
                    })
                }));
                setStep({
                    stepId: result.seriesSteps[currentStepIndex].seriesStepId,
                    amountOfDaysForShift: result.seriesSteps[currentStepIndex].amountOfDaysForShift,
                    textMessage: result.seriesSteps[currentStepIndex].textMessage,
                    transportIds: result.seriesSteps[currentStepIndex].transports,
                    ignoreSentMessagesToGuest: result.seriesSteps[currentStepIndex].ignoreSentMessagesToGuest,
                    seriesId: result.seriesId,
                    stepNumber: currentStepIndex,
                    moveSendingToNextDay: result.seriesSteps[currentStepIndex].moveSendingToNextDay,
                    executorParam: result.seriesSteps[currentStepIndex].seriesStepExecutorParam,
                    seriesImagePathForFrontend: result.seriesSteps[currentStepIndex].seriesImagePathForFrontend,
                    plannedStartDate: result.seriesSteps[currentStepIndex].plannedStartDate,
                    fileNameForFrontend: result.seriesSteps[currentStepIndex].fileNameForFrontend,
                });
                setFileName(result.seriesSteps[currentStepIndex].fileNameForFrontend)
                setImage(null)
            }
            setIsDisabledNewStep(false);
            setDisableRequest(false);
        }
        setEditing(false)
        setEditingStep(false)
        setDisableRequest(false)
    };

    const deleteStep = async () => {
        setDisableRequest(true);

        const response = await fetch(`/api/series-step/${step.stepId}/delete`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            },
        });
        const result = await response.json();

        if (result.success === 0) {
            setImportError(result.message);
            setError(true);

            return
        }

        if (result.length) {
            setSerial(prev => ({
                ...prev,
                seriesSteps: result.sort((a, b) => a.stepNumber - b.stepNumber)
            }));

            setSerialOriginalData(prev => ({
                ...prev,
                seriesSteps: result.sort((a, b) => a.stepNumber - b.stepNumber)
            }))

            setCurrentStepIndex(prevIndex => {
                return Math.max(0, Math.min(prevIndex - 1, result.length - 1));
            });

            setStep({
                stepId: result[result.length - 1].seriesStepId,
                amountOfDaysForShift: result[result.length - 1].amountOfDaysForShift,
                textMessage: result[result.length - 1].textMessage,
                transportIds: result[result.length - 1].transports,
                ignoreSentMessagesToGuest: result[result.length - 1].ignoreSentMessagesToGuest,
                stepNumber: result[result.length - 1].stepNumber,
                moveSendingToNextDay: result[result.length - 1].moveSendingToNextDay,
                executorParam: result[result.length - 1].seriesStepExecutorParam,
                seriesImagePathForFrontend: result[result.length - 1].seriesImagePathForFrontend,
                plannedStartDate: result[result.length - 1].plannedStartDate,
                fileNameForFrontend: result[result.length - 1].fileNameForFrontend,
            })

            setFileName(result[result.length - 1].fileNameForFrontend)
        }

        setDisableRequest(false);
        setDeleteStepDialog(false);
    };

    const startSeries = async () => {
        setDisableRequest(true);

        const response = await fetch(`/api/series/${serial.seriesId}/start`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            }
        });
        let result = await response.json();

        result.series[0].seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber);

        if (result.series.length) {
            setSerial(result.series[0]);
            setSerialOriginalData(result.series[0]);

            const [day, month, year] = result.series[0].dateStart.split(".");
            const startDate = new Date(+year, +month - 1, +day);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (startDate <= today) {
                setAlarmMessage(true);
            }
        }

        setDisableRequest(false);
    };

    const pauseSeries = async () => {
        setDisableRequest(true);

        const response = await fetch(`/api/series/${serial.seriesId}/pause-from-info`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            }
        });
        let result = await response.json();

        result.series[0].seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber);

        if (result.series.length) {
            setSerial(result.series[0]);
            setSerialOriginalData(result.series[0]);
        }

        setDisableRequest(false);
    };

    const resumeSeries = async () => {
        setDisableRequest(true);

        const response = await fetch(`/api/series/${serial.seriesId}/resume-from-info`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            }
        });

        const text = await response.text();

        const jsonStart = text.indexOf('{');
        if (jsonStart === -1) {
            console.log('json не найден');
            setDisableRequest(false);
            return;
        }

        const json = JSON.parse(text.slice(jsonStart));

        json.series[0].seriesSteps.sort((a, b) => a.stepNumber - b.stepNumber);

        if (json.series.length) {
            setSerial(json.series[0]);
            setSerialOriginalData(json.series[0]);
        }

        setDisableRequest(false);
    };

    const stopSeries = async () => {
        setDisableRequest(true);

        const response = await fetch(`/api/series/${serial.seriesId}/stop-from-info`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            }
        });
        const result = await response.json();

        if (result?.success === 0) {
            return
        }

        if (result.series.length) {
            setSerial(result.series[0]);
        }

        setDisableRequest(false);
        setStopSeriesDialog(false);
    };

    const deleteSeries = async () => {
        setDisableRequest(true);

        await fetch(`/api/series/${serial.seriesId}/delete`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            }
        });

        setDisableRequest(false);
        history.push('/series');
    };

    const handleChangeFile = (event) => {
        // setImportFileName(null);
        setImportError(null);

        const file = event.target.files[0];

        parseXLS(file).then((json) => {
            const DTOArray = phonesXLSXRowsToDTOArray(json);

            if (!Array.isArray(DTOArray)) {
                setImportError(DTOArray);
                setError(true);
                setTimeout(() => setError(false), 3000);
                return;
            }

            const raw = DTOArray
                .map(v => String(v.phone ?? '').trim())
                .filter(Boolean)
                .filter(p => /^\+?\d+$/.test(p))
                .map(p => (p.startsWith('++') ? p.slice(1) : p));

            if (serial?.isWarmingUpSeries) {
                setSerial({
                    ...serial,
                    phoneNumbers: raw,
                });

                return;
            }

            const unique = [];
            const byLast10 = new Map();
            const seenUniform10 = new Set();

            for (let p of raw) {
                const digits = p.replace(/\D/g, '');
                if (digits.length < 9) continue;

                if (/^(?:\+7|7|8)/.test(p)) {
                    const tail = digits.replace(/^(\+?7|8)/, '');
                    if (tail.length !== 10) {
                        continue;
                    }
                }

                const key10 = digits.slice(-10);
                const key = key10.length === 10 ? key10 : digits;

                const isUniform10 = key.length === 10 && /^(\d)\1{9}$/.test(key);
                if (isUniform10) {
                    if (seenUniform10.has(key)) continue;
                    seenUniform10.add(key);
                }

                if (byLast10.has(key)) {
                    const idx = byLast10.get(key);
                    if (p.startsWith('+') && !unique[idx].startsWith('+')) {
                        unique[idx] = p;
                    }
                    continue;
                }

                byLast10.set(key, unique.length);
                unique.push(p);
            }

            setSerial({
                ...serial,
                phoneNumbers: unique
            });
        });
    }

    const handleChange = (field) => (e) => {
        let value = e.target.value;

        if (value === null) {
            value = "";
        }

        if (value.length > 100) return;
        setSerial(prev => ({ ...prev, [field]: value }));
    };

    const handleSerialChange = (prop) => (value) => {
        setSerial(prev => {
            // const start = parseTimeStringToDate(prev.timeOfStartSending);
            // const end = parseTimeStringToDate(prev.timeOfEndSending);
            //
            // if (prop === "timeOfEndSending" && start && value && value.isBefore(start, "minute")) {
            //     value = start.clone();
            // }
            //
            // if (prop === "timeOfStartSending" && end && value && value.isAfter(end, "minute")) {
            //     value = end.clone();
            // }

            return {
                ...prev,
                [prop]: value,
            };
        });
    };

    const handleSerialChangeTime = (prop) => (value) => {
        setSerial(prev => {
            let newValue = moment(value);

            return {
                ...prev,
                [prop]: newValue.format("HH:mm"),
            };
        });
    };



    const handleAnyFieldChange = (prop) => (e) => {
        setSerial(prev => ({ ...prev, [prop]: e.target.value }));
    };

    const goBack = () => {
        if (editing && serial.seriesId) {
            setIsDuplicated(false)
            setEditing(false);
            setEditingStep(false)
            setSerial(serialOriginalData);
            setCurrentStepIndex(0)
            handleStep(0)
            history.push(`/series/view/${serial.seriesId}`);
        } else {
            history.push('/series');
        }
    };

    const switchToEdit = () => {
        setEditing(true);
        history.push(`/series/edit/${serial.seriesId ?? 0}`);
    };

    const switchMailingBase = (val) => {
        setSwitcher(val === "executor");
    };

    const handleEditStep = () => {
        setEditingStep(true);
        setIsDisabledNewStep(false);
    }

    const handleStepCheckboxChange = (field) => (e) => {
        const checked = e.target.checked;

        setStep(prev => ({
            ...prev,
            [field]: checked,
        }));
    };

    const handleStepFieldChange = (field) => (e) => {
        if (field === 'transportIds') {
            const valueForTransports = e.target.value || [];

            const selected = valueForTransports.map(v => {
                const id = (typeof v === 'object' && v !== null) ? v.id : v;
                return mailingList.find(i => i.id === id) || (typeof v === 'object' ? v : null);
            }).filter(Boolean);

            let newType;
            if (selected.length) {
                const firstId = (typeof selected[0] === 'object') ? selected[0].id : selected[0];
                newType = findTransportTypeByChannelId(firstId) || selectedTransportType;
            } else {
                newType = selectedTransportType;
            }

            let limit = null;
            if (newType === 'megafon') {
                const channels = transportChannelsMap[newType] || [];
                const selectedIds = (selected || []).map(s => (typeof s === 'object' ? s.id : s));
                const source = selectedIds.length ? channels.filter(ch => selectedIds.includes(ch.id)) : channels;
                const nums = source.map(ch => Number(ch.amountOfLetters)).filter(n => !isNaN(n) && n > 0);
                if (nums.length) limit = Math.min(...nums);
            }

            setStep(prev => {
                let newText = prev.textMessage || '';
                if (limit && newText.length > limit) {
                    newText = newText.slice(0, limit);
                    setImportError(`Сообщение автоматически обрезано до максимальной длины канала: ${limit} символа(ов)`);
                    setError(true);
                }

                return { ...prev, transportIds: selected, textMessage: newText };
            });

            if (newType) setSelectedTransportType(newType);

            return;
        }

        if (field === 'executorParam') {
            let value = e.target.value;
            const validNames = executorsListForSteps.map(item => item.name);
            const filtered = (value || []).filter(name => validNames.includes(name));
            setStep(prev => ({ ...prev, executorParam: filtered }));
            return;
        }

        if (field === 'textMessage') {
            let value = e.target.value || '';
            const limit = getMessageLimit();
            if (limit && value.length > limit) {
                value = value.slice(0, limit);
                setImportError(`Максимальная длина сообщения для выбранного канала: ${limit} символа(ов)`);
                setError(true);
            }
            setStep(prev => ({ ...prev, textMessage: value }));
            return;
        }

        let value = e.target.value;
        if (value === null) value = '';
        setStep(prev => ({ ...prev, [field]: value }));
    };

    const addNewStep = () => {
        if (serial.seriesSteps.length >= 10) return;

        const newStepNumber = serial.seriesSteps.length + 1;
        const newStep = {
            seriesStepId: null,
            stepNumber: newStepNumber,
            stepStatus: '',
            moveSendingToNextDay: false,
            textMessage: '',
            transports: [],
            transportType: '',
            ignoreSentMessagesToGuest: false,
            amountOfDaysForShift: 1,
            amountOfSeriesActionsForHandle: 0,
            amountOfHandledSeriesActions: 0,
            seriesStepExecutorParam: '',
            seriesImagePathForFrontend: null,
            plannedStartDate: null,
        };

        setSerial(prev => ({
            ...prev,
            seriesSteps: [...prev.seriesSteps, newStep]
        }));

        setIsDisabledNewStep(true);
        setImage(null);
        setFileName("");
        setCurrentStepIndex(serialOriginalData.seriesSteps.length);
        setStep(emptyStep);
        setEditingStep(false);
    };

    const handleStep = (index) => {
        if (isDuplicated && index !== 0) {
            return;
        }//TODO блокировка пока не починим

        setCurrentStepIndex(index);

        setEditingStep(false);

        if (serial.seriesSteps[index].seriesStepId) {
            setStep({
                    stepId: serial.seriesSteps[index].seriesStepId,
                    amountOfDaysForShift: serial.seriesSteps[index].amountOfDaysForShift,
                    textMessage: serial.seriesSteps[index].textMessage,
                    transportIds: serial.seriesSteps[index].transports,
                    ignoreSentMessagesToGuest: serial.seriesSteps[index].ignoreSentMessagesToGuest,
                    seriesId: serial.seriesId,
                    stepNumber: currentStepIndex,
                    moveSendingToNextDay: serial.seriesSteps[index].moveSendingToNextDay,
                    executorParam: serial.seriesSteps[index].seriesStepExecutorParam,
                    seriesImagePathForFrontend: serial.seriesSteps[index].seriesImagePathForFrontend,
                    plannedStartDate: serial.seriesSteps[index].plannedStartDate,
                fileNameForFrontend: serial.seriesSteps[index].fileNameForFrontend,
            })
            setFileName(serial.seriesSteps[index].fileNameForFrontend)
            setImage(null)
            setIsDisabledNewStep(false);
        } else {
            setIsDisabledNewStep(true);
            setStep(emptyStep)
            setFileName("")
            setImage(null)
        }
    };

    const handleCounter = (value) => {
        if (value === 'plus') {
            setStep(prev => ({
                ...prev,
                amountOfDaysForShift: prev.amountOfDaysForShift + 1
            }))
        } else {
            if (step.amountOfDaysForShift === 1) return;

            setStep(prev => ({
                ...prev,
                amountOfDaysForShift: prev.amountOfDaysForShift - 1
            }))
        }
    }

    const downloadExample = () => {
        window.open('/template-series.xlsx')
    }

    const disableStopButton = () => {
        return serial.seriesStatus === 'ready' || serial.seriesStatus === 'stopped' || serial.seriesStatus === 'finished'
    }

    const handleImageChange = (event) => {
        const input = event.target;
        const file = input.files?.[0];
        if (!file) return;

        const resetInput = () => { input.value = ""; };

        if (!["image/png", "image/jpeg"].includes(file.type)) {
            alert("Допустимы только PNG или JPG.");
            return resetInput();
        }

        if (file.size > 5 * 1024 * 1024) {
            alert("Файл не должен превышать 5MB.");
            return resetInput();
        }

        const img = new Image();
        img.onload = () => {
            if (img.width > 1200 || img.height > 800) {
                alert("Максимальное разрешение 1200x800px.");
                return resetInput();
            }

            setImage(file);
            setFileName(file.name);
            resetInput();
        };
        img.src = URL.createObjectURL(file);
    };

    const deleteImageStep = async () => {
        if (!step.stepId) {
            setFileName("");
            setImage(null)

            return
        }

        if (!serial.seriesSteps[currentStepIndex].seriesImagePathForFrontend) {
            setFileName("");
            setImage(null)

            return
        }

        setDisableRequest(true);

        const response = await fetch(`/api/series-step-image/${step.stepId}/delete`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${getAccessToken()}`,
            },
        });
        const result = await response.json();

        if (result.success === 0) {
            setImportError(result.message);
            setError(true);

            return
        }

        if (result.success === 1) {
            setSerial(prev => ({
                ...prev,
                seriesSteps: prev.seriesSteps.map((step, index) => {
                    return (
                        index === currentStepIndex
                            ? { ...step, seriesImagePathForFrontend: null }
                            : step
                    )
                })
            }));

            setDisableRequest(false);
            setImage(null);
            setFileName("");
        }
    };

    const handleDeleteStep = () => {
        setEditingStep(false)
        setDeleteStepDialog(true)
    }

    const disabledUploadXLS = () => {
        if (!isDuplicated) {
            return (id !== '0' || !editing || serial.seriesStatus !== "ready" || serial.seriesExecutorParam.length)
        } else {
            return serial.seriesExecutorParam.length
        }
    }
    const disabledExecutor = () => {
        if (!isDuplicated) {
            return (!editing || serial.seriesSteps[0].amountOfSeriesActionsForHandle > 0 ||
                serial.seriesStatus !== "ready" || serial?.phoneNumbers?.length)
        } else {
            return serial.seriesSteps[0].amountOfSeriesActionsForHandle > 0 || serial?.phoneNumbers?.length
        }
    }

    const executorValue = React.useMemo(() => {
        if (!serial.seriesExecutorParam) return null;

        const found = executorsList.find(i => i.name === serial.seriesExecutorParam);

        return found
            ? { value: found.name, text: found.comment }
            : { value: serial.seriesExecutorParam, text: serial.seriesExecutorParam };
    }, [serial.seriesExecutorParam, executorsList]);

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks} fakeLink={t('Serial')} />}>
                <ShowField
                    label={t("Дата создания серии")}
                    value={serial.createdAt}
                    visible={!!serial.createdAt}
                    fullWidth
                />
                <ShowField
                    label={t("Создатель")}
                    value={serial.creator}
                    visible={!!serial.creator}
                    fullWidth
                />
                <ShowField
                    label={t("Статус серии")}
                    value={t(serial.seriesStatus)}
                    visible={!!serial.seriesStatus}
                    fullWidth
                />
                {
                    !editing ?
                        <ActionButton onClick={switchToEdit} disabled={id !== "0" && (serial.seriesStatus === "stopped" || serial.seriesStatus === "finished")}>{t("Edit serial")}</ActionButton>
                    :
                        <ActionButton onClick={id === "0" ? createStep : saveSerial} disabled={editingStep || disableRequest || isDisabledNewStep}>{t("Save series")}</ActionButton>
                }
                <ActionButton onClick={createDuplicateSeries} disabled={isDuplicated || editingStep || isDisabledNewStep || id === '0' || editing}>{t("Create copy")}</ActionButton>
                <ActionButton onClick={() => setStopSeriesDialog(true)} disabled={disableStopButton() || disableRequest} >{t("Series stop")}</ActionButton>
                <ActionButton onClick={() => setDeleteSeriesDialog(true)} disabled={id === '0' || serial.seriesStatus !== 'ready' || disableRequest || editingStep || isDisabledNewStep} >{t("Series delete")}</ActionButton>
                <ActionButton onClick={goBack} >{t("Back")}</ActionButton>
            </LeftBar>
            <Content title={t('Serial')} notFoundContent={notFound}>
                <Grid container justifyContent="space-between" alignItems="flex-start">
                    <Grid item xs={4}>
                        <AnyField
                            id="serialName"
                            label={t("Series name")}
                            value={serial.name}
                            onChange={handleChange('name')}
                            fullWidth
                            required
                            disabled={(!editing || serial.seriesStatus !== "ready") && !isDuplicated}
                        />
                        <div className={classes.counterContainer}>Количество символов <span className={classes.counter}>{serial.name?.length ?? 0}/100</span></div>
                    </Grid>
                    {
                        serial.seriesStatus !== 'stopped' && serial.seriesStatus !== 'finished' && !isDuplicated && <div>
                            {
                                serial.seriesStatus === 'ready' ?
                                    <Grid item>
                                        <ActionButton onClick={startSeries} disabled={(!serial.seriesId || disableRequest || editing) && !isDuplicated}
                                                      className={classes.topRightButton}><PlayArrow
                                            style={{marginRight: "8px "}}/> {t("Launch series")}</ActionButton>
                                    </Grid>
                                    :
                                    serial.seriesStatus === 'paused' ?
                                        <Grid item>
                                            <ActionButton onClick={resumeSeries} disabled={(!serial.seriesId || disableRequest || editing) && !isDuplicated}
                                                          className={classes.topRightButton}><Replay
                                                style={{marginRight: "8px "}}/> {t("Resume series")}</ActionButton>
                                        </Grid>
                                        :
                                        <Grid item>
                                            <ActionButton onClick={pauseSeries} disabled={(!serial.seriesId || disableRequest || editing) && !isDuplicated}
                                                          className={classes.topRightButtonPause}><Pause
                                                style={{marginRight: "8px "}}/> {t("Pause series")}</ActionButton>
                                        </Grid>
                            }
                        </div>
                    }
                </Grid>
                <Grid xs={12}>
                    <div className={classes.emptyLine}></div>
                </Grid>
                <Grid container>
                    <Grid xs={12} item>
                        <h2>{t("Общие настройки")}</h2>
                    </Grid>
                    <Grid xs={3} item>
                        <h3 className={classes.settingsTitle}>{t("Настройки графика рассылки")}</h3>
                        <DateField
                            label={t('Date')}
                            value={serial.dateStart ? moment(serial.dateStart, "DD.MM.YYYY") : null}
                            onChange={(date) => {
                                const normalized = moment(date).startOf('day');
                                if (!normalized.isSameOrBefore(moment(), 'day')) {
                                    handleSerialChange('dateStart')(normalized.format("DD.MM.YYYY"));
                                }
                            }}
                            initialFocusedDate={serial.dateStart ? moment(serial.dateStart, "DD.MM.YYYY") : moment().add(1, 'day')}
                            fullWidth
                            shouldDisableDate={(date) => {
                                return moment(date).isSameOrBefore(moment(), 'day');
                            }}
                            disabled={(!editing || serial.seriesStatus !== "ready") && !isDuplicated}
                        />
                        <div>
                            <CheckboxField
                                label={t("Warming up series")}
                                value={serial.isWarmingUpSeries}
                                onChange={handleChange("isWarmingUpSeries")}
                                disabled={
                                    ((!editing || serial.seriesStatus !== "ready") && !isDuplicated) ||
                                    (isCreatingFirstStep && !isGreenApiTransportType(selectedTransportType))
                                }
                            />
                        </div>
                    </Grid>
                    <Grid item>
                    <div className={classes.verticalEmptyLine}></div>
                    </Grid>
                    <Grid container xs={3} style={{ justifyContent: "space-between" }}>
                        <h3 className={classes.settingsTitle} style={{marginBottom: "-15px"}}>{t("Настройки времени рассылки")}</h3>
                        <SelectFromItemsField
                            label={t('Timezone')}
                            value={serial.timeZone}
                            onChange={handleAnyFieldChange('timeZone')}
                            fullWidth
                            items={utcList}
                            disabled={(!editing || serial.seriesStatus !== "ready") && !isDuplicated}
                            textField="text"
                            valueField="value"
                        />
                        <Grid item xs={5}>
                            <TimeField
                                label={t('Start')}
                                value={parseTimeStringToDate(serial.timeOfStartSending)}
                                onChange={handleSerialChangeTime('timeOfStartSending')}
                                disabled={(!editing || serial.seriesStatus !== "ready") && !isDuplicated}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TimeField
                                label={t('End')}
                                value={parseTimeStringToDate(serial.timeOfEndSending)}
                                onChange={handleSerialChangeTime('timeOfEndSending')}
                                disabled={(!editing || serial.seriesStatus !== "ready") && !isDuplicated}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <div className={classes.verticalEmptyLine}></div>
                    </Grid>
                    <Grid container xs={4}>
                        <h3 className={classes.settingsTitle} style={{marginBottom: "27px"}}>{t("Выбор номеров для рассылки")}</h3>
                        <Grid item xs={12}>
                            <div className={classes.switcher}>
                                <button
                                    className={!switcher ? classes.activeBtn : classes.inactiveBtn}
                                    onClick={() => switchMailingBase("base")}
                                >
                                    Загрузка базы
                                </button>
                                <button
                                    className={switcher ? classes.activeBtn : classes.inactiveBtn}
                                    onClick={() => switchMailingBase("executor")}
                                >
                                    Выбор экзекутора
                                </button>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {!switcher && (
                                <div className={classes.actions}>
                                    {(serial.seriesSteps[0].amountOfSeriesActionsForHandle === 0 && !serial?.phoneNumbers?.length) || serial.seriesExecutorParam.length
                                        ? <UploadFilesField
                                            id="importFile"
                                            label={t("Send by xlsx file")}
                                            value={null}
                                            onChange={handleChangeFile}
                                            notLoad
                                            fullWidth={false}
                                            disabled={disabledUploadXLS()}
                                            padding="8px 22px"
                                        />
                                        : <div style={{ width: "40%", display: "flex", flexDirection: "column" }}>
                                            <span>Файл был загружен, загружено номеров: {serial?.phoneNumbers?.length ? serial.phoneNumbers.length : serial.seriesSteps[0].amountOfSeriesActionsForHandle}</span>
                                            <ActionButton onClick={() => setSerial({...serial, phoneNumbers: []})} style={{ padding: "8px 22px", width: "fit-content" }} disabled={id !== '0' && !isDuplicated}>Удалить</ActionButton>
                                        </div>
                                    }
                                    <button className={classes.downloadBtn} onClick={downloadExample}>Скачать шаблон</button>
                                </div>
                            )}

                            {switcher && (
                                <SelectFromItemsField
                                    label={t("Select executor")}
                                    value={serial.seriesExecutorParam}
                                    onChange={handleChange('seriesExecutorParam')}
                                    fullWidth
                                    items={!editing ? executorValue ? [executorValue] : [] : executorsList.sort((a, b) => a.comment.localeCompare(b.comment))}
                                    textField="text"
                                    valueField="value"
                                    nullable
                                    disabled={disabledExecutor()}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12}>
                    <div className={classes.emptyLine}></div>
                </Grid>
                <Grid container>
                    <Grid container justifyContent="space-between" alignItems="flex-start">
                        <h2>{t("Шаги рассылки")}</h2>
                        <Grid item className={classes.counterContainer} style={{ gap: "12px" }}>
                            {serial.seriesSteps[currentStepIndex] && serial.seriesSteps[currentStepIndex].seriesStepId !== null &&
                                <Grid item>
                                    <ActionButton
                                        onClick={handleEditStep}
                                        disabled={
                                            !editing ||
                                            editingStep ||
                                            !serial.seriesSteps[currentStepIndex].seriesStepId ||
                                            !step.textMessage || !step.transportIds ||
                                            serial.seriesSteps[currentStepIndex].stepStatus !== 'new' ||
                                            isDuplicated
                                        }
                                        style={{ padding: "8px 10px" }}
                                    >
                                        {t("Edit step")}
                                    </ActionButton>
                                </Grid>
                            }
                            {serial.seriesSteps[0].seriesStepId &&
                                <Grid item>
                                    <ActionButton
                                        onClick={createStep}
                                        disabled={
                                            ((!editing ||
                                            !serial.seriesSteps[currentStepIndex] ||
                                            (!editingStep && serial.seriesSteps[currentStepIndex].seriesStepId !== null) ||
                                            !step.textMessage || !step.transportIds) && !isDisabledNewStep) ||
                                            isDuplicated || disableRequest
                                        }
                                        style={{ padding: "8px 10px" }}
                                    >
                                        {t("Save step")}
                                    </ActionButton>
                                </Grid>
                            }
                            {currentStepIndex > 0 && serial.seriesSteps.length === currentStepIndex + 1 &&
                                <Grid item>
                                    <ActionButton
                                        onClick={handleDeleteStep}
                                        className={classes.deleteButton}
                                        disabled={
                                            !editing ||
                                            !serial.seriesSteps[currentStepIndex] ||
                                            !serial.seriesSteps[currentStepIndex].stepStatus.length ||
                                            serial.seriesSteps[currentStepIndex].stepStatus !== 'new' ||
                                            disableRequest || isDuplicated
                                        }
                                    >
                                        {t("Delete step")}
                                    </ActionButton>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <Grid item style={{ marginBottom: "16px" }}>
                        {serial?.seriesSteps?.map((step, index) => {
                            const isActive = index === currentStepIndex;
                            const isFirst = index === 0;
                            const isLast = index === serial.seriesSteps.length - 1;
                            const isDisabled = isDuplicated && index > 0;

                            let classNames = `${isActive ? classes.activeStepBtn : classes.stepBtn}`;
                            if (isFirst) classNames += ` ${classes.firstStepBtn}`;
                            if (isLast) classNames += ` ${classes.lastStepBtn}`;
                            if (isDisabled) classNames += ` ${classes.disabledStepBtn}`;

                            return (
                                <button
                                    key={index}
                                    className={classNames}
                                    onClick={() => handleStep(index)}
                                    disabled={isDuplicated && index !== 0}//TODO блокировка пока не починим
                                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                >
                                    Шаг {step.stepNumber || index + 1}
                                </button>
                            );
                        })}
                        <button
                            disabled={!isFirstStepSaved || serial?.seriesSteps?.length >= 10 || !editing || serial.seriesStatus === 'finished' || serial.seriesStatus === 'stopped' || serial?.seriesSteps?.length > serialOriginalData?.seriesSteps?.length || isDuplicated }
                            className={classes.addStepBtn}
                            onClick={addNewStep}
                        >
                            Добавить шаг
                            <Add />
                        </button>
                    </Grid>
                    <Grid container style={{ backgroundColor: "#ffffff", borderRadius: "10px", border: "1px solid #DCDCDC", padding: "32px" }}>
                        {serial?.seriesSteps[currentStepIndex]?.stepStatus &&
                            <Grid item xs={12}>
                                <div className={classes.titleStatusStep}>
                                    Статус шага: <span style={{ color: "#000000DE" }}>{translateStepStatus(serial.seriesSteps[currentStepIndex].stepStatus)}</span>
                                </div>
                            </Grid>
                        }
                        <Grid container wrap="nowrap">
                            <Grid item xs={3} style={{ maxWidth: "320px", width: "25%" }}>
                                <h3 style={{ marginBlockStart: "0" }}>Каналы</h3>
                                <SelectFromItemsField
                                    label="Транспорт"
                                    items={editing
                                        ? ((serial.isWarmingUpSeries && !isCreatingFirstStep)
                                            ? transportTypes.filter(item => isGreenApiTransportType(item.value))
                                            : (transportTypes.length ? transportTypes : []))
                                        : (selectedTransportType ? [{ value: selectedTransportType, text: selectedTransportType }] : [])}
                                    value={selectedTransportType}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        setSelectedTransportType(val);
                                        setStep(prev => ({ ...prev, transportIds: [] }));

                                        const isMegafon = val.toLowerCase().includes('megafon');

                                        if (isMegafon) {
                                            setImage(null);
                                            setFileName(null);
                                        }
                                    }}
                                    fullWidth
                                    style={{ maxWidth: "320px", marginBottom: 12 }}
                                    valueField="value"
                                    textField="text"
                                    disabled={!editing || !!step?.stepId}
                                />
                                <SelectFromItemsField
                                    label="Выберите канал"
                                    items={itemsForSelect}
                                    value={(step.transportIds || []).map(i => i.id)}
                                    onChange={handleStepFieldChange('transportIds')}
                                    fullWidth
                                    style={{ maxWidth: "320px" }}
                                    valueField="id"
                                    textField="name"
                                    disabled={(!selectedTransportType && editing) || isStepLocked()}
                                    SelectProps={{
                                        multiple: true,
                                        renderValue: selectedIds => {
                                            if (!selectedIds || !selectedIds.length) return null;
                                            return itemsForSelect
                                                .filter(item => selectedIds.includes(item.id))
                                                .map(item => item.name)
                                                .join(', ');
                                        }
                                    }}
                                    customItemLabel={item => (
                                        <>
                                            <Checkbox checked={(step.transportIds || []).map(i => i.id).includes(item.id)} />
                                            <ListItemText primary={item.name} />
                                        </>
                                    )}
                                />
                                {currentStepIndex > 0 &&
                                    <div>
                                        <h3>Параметры фильтрации</h3>
                                        <SelectFromItemsField
                                            label={t("Executor name")}
                                            items={executorsListForSteps.sort((a, b) => a.comment.localeCompare(b.comment))}
                                            value={(step.executorParam || [])}
                                            onChange={handleStepFieldChange('executorParam')}
                                            fullWidth
                                            style={{ maxWidth: "320px" }}
                                            valueField="value"
                                            textField="text"
                                            disabled={
                                                ((!editing || (!editingStep && id !== '0')) &&
                                                (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                            }
                                            SelectProps={{
                                                multiple: true,
                                                renderValue: selectedNames => {
                                                    if (!selectedNames || !selectedNames.length) return null;
                                                    return selectedNames
                                                        .map(name => {
                                                            const found = executorsListForSteps.find(item => item.name === name)
                                                            return found ? found.comment : name
                                                        })
                                                        .join(', ');
                                                }
                                            }}
                                            customItemLabel={item => (
                                                <>
                                                    <Checkbox checked={(step.executorParam || []).includes(item.name)} />
                                                    <ListItemText primary={item.comment} />
                                                </>
                                            )}
                                        />
                                    </div>
                                }
                            </Grid>
                            <Grid item>
                                <div className={classes.verticalEmptyLine}></div>
                            </Grid>
                            <Grid item xs={3}>
                                <h3 style={{ marginBlockStart: "0" }}>Настройки графика рассылки</h3>
                                {serial?.seriesSteps[currentStepIndex]?.plannedStartDate &&
                                    <div className={classes.amountStepLabel} style={{ marginTop: "-8px", marginBottom: currentStepIndex > 0 ? "16px" : "0" }}>
                                        Дата запуска <span style={{ color: "#000000" }}>{serial.seriesSteps[currentStepIndex].plannedStartDate}</span>
                                    </div>
                                }
                                {currentStepIndex > 0 &&
                                    <div className={classes.amountStep}>
                                        <div>
                                            <AnyField
                                                id="amountOfDaysForShift"
                                                value={step.amountOfDaysForShift}
                                                onChange={handleStepFieldChange('amountOfDaysForShift')}
                                                fullWidth
                                                required
                                                disabled
                                            />
                                            <div className={classes.amountStepLabel}>
                                                Старт шага через количество дней после завершения предыдущего шага
                                            </div>
                                        </div>
                                        <ActionButton
                                            onClick={() => handleCounter('minus')}
                                            style={{
                                                maxWidth: "36px",
                                                height: "35px",
                                                marginLeft: "4px",
                                                marginTop: "0",
                                                minWidth: "36px"
                                            }}
                                            disabled={
                                                ((!editing || (!editingStep && id !== '0')) &&
                                                (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                            }                                      >
                                            <Remove fontSize="small" htmlColor="#000000"/>
                                        </ActionButton>
                                        <ActionButton
                                            onClick={() => handleCounter('plus')}
                                            style={{
                                                maxWidth: "36px",
                                                height: "35px",
                                                marginLeft: "4px",
                                                marginTop: "0",
                                                minWidth: "36px"
                                            }}
                                            disabled={
                                                ((!editing || (!editingStep && id !== '0')) &&
                                                (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                            }                                      >
                                            <Add fontSize="small" htmlColor="#000000"/>
                                        </ActionButton>
                                    </div>
                                }
                                <Grid item xs={12} className={classes.item}>
                                    <CheckboxField
                                        label={t("Postpone the mailing to the next day")}
                                        value={step.moveSendingToNextDay}
                                        onChange={handleStepCheckboxChange("moveSendingToNextDay")}
                                        disabled={
                                            ((!editing || (!editingStep && id !== '0')) &&
                                            (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                        }                                  />
                                </Grid>
                                <Grid item xs={12} className={classes.item}>
                                    <CheckboxField
                                        label={t("Ignore checking of sent messages to the client")}
                                        value={step.ignoreSentMessagesToGuest}
                                        onChange={handleStepCheckboxChange("ignoreSentMessagesToGuest")}
                                        disabled={
                                            ((!editing || (!editingStep && id !== '0')) &&
                                            (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                        }                                  />
                                </Grid>
                            </Grid>
                            <Grid item>
                                <div className={classes.verticalEmptyLine}></div>
                            </Grid>
                            <Grid item xs>
                                <h3 style={{marginBlockStart: "0"}}>Сообщение</h3>
                                {isGreenApiTransportType(selectedTransportType) &&
                                    <Typography variant="body2" style={{ marginBottom: 8, color: "#757575" }}>
                                        При отправке через канал Green Api будет использована подмена текста и персонализация сообщений через экзекутер
                                    </Typography>
                                }
                                <AnyField
                                    id="Text"
                                    label={t("Message text")}
                                    value={step.textMessage}
                                    onChange={handleStepFieldChange('textMessage')}
                                    fullWidth
                                    required={true}
                                    multiline
                                    rows={3}
                                    disabled={
                                        (((!editing || (!editingStep && id !== '0')) &&
                                                (serial.seriesSteps[currentStepIndex]?.seriesStepId !== null || !editing)) || (isDuplicated && currentStepIndex > 0)
                                        )
                                    }
                                    maxLength={getMessageLimit() || undefined}
                                />
                                <div style={{ display: "flex", alignItems: fileName ? "flex-end" : "center", gap: 10, marginTop: "16px" }}>
                                    {((!transportTypes.length) || selectedTransportType === 'green_api') && !fileName &&
                                        <div style={{display: "flex", flexDirection: "column"}}>
                                            {!fileName && (
                                                <Typography variant="body2" style={{marginBottom: 4}}>
                                                    {fileName}
                                                </Typography>
                                            )}
                                            <input
                                                accept="image/png, image/jpeg"
                                                style={{display: "none"}}
                                                id="upload-image-input"
                                                type="file"
                                                disabled={isStepLocked()}
                                                onChange={handleImageChange}
                                            />
                                            <label htmlFor="upload-image-input">
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    component="span"
                                                    size="small"
                                                    style={{padding: " 8px 10px", whiteSpace: "nowrap"}}
                                                    disabled={isStepLocked()}
                                                >
                                                    Загрузить изображение
                                                </Button>
                                            </label>
                                        </div>
                                    }
                                    {fileName &&
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            {serial.seriesSteps[currentStepIndex]?.seriesImagePathForFrontend &&
                                                <img
                                                    src={serial.seriesSteps[currentStepIndex].seriesImagePathForFrontend.replace(/^\/uploads/, "")}
                                                    alt="img"
                                                    style={{width: "160px", height: "160px", objectFit: "cover"}}
                                                />
                                            }
                                            <Typography variant="caption" color="textSecondary" style={{ marginTop: "20px" }}>
                                                {fileName}
                                            </Typography>
                                        </div>
                                    }
                                    {!fileName && ((!transportTypes.length) || selectedTransportType === 'green_api') &&
                                        <Typography variant="caption" color="textSecondary">
                                            PNG, или JPG (максимальное разрешение 1200x800px), не более 5MB
                                        </Typography>
                                    }
                                    {fileName &&
                                        <ActionButton
                                            onClick={deleteImageStep}
                                            style={{ padding: " 8px 10px", width: "fit-content" }}
                                            disabled={isStepLocked() || disableRequest}
                                        >
                                            Удалить
                                        </ActionButton>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Dialog open={error} onClose={() => setError(false)}>
                    <DialogTitle id="dialog-title">{importError}</DialogTitle>
                </Dialog>

                <Dialog open={deleteStepDialog} onClose={() => setDeleteStepDialog(false)}>
                    <div className={classes.dialogContainer}>
                        <DialogTitle>Удалить шаг</DialogTitle>
                        <DialogContent>
                            Вы уверены, что хотите удалить шаг?
                        </DialogContent>
                        <DialogActions>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                onClick={() => setDeleteStepDialog(false)}
                                style={{ backgroundColor: "transparent", border: "1px solid #FFC107", boxShadow: "none" }}
                            >
                                {t("Cancel")}
                            </ActionButton>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                disabled={disableRequest}
                                onClick={deleteStep}
                                style={{ boxShadow: "none" }}
                            >
                                {t("Delete")}
                            </ActionButton>
                        </DialogActions>
                    </div>
                </Dialog>

                <Dialog open={deleteSeriesDialog} onClose={() => setDeleteSeriesDialog(false)}>
                    <div className={classes.dialogContainer}>
                        <DialogTitle>Удалить серию</DialogTitle>
                        <DialogContent>
                            Вы уверены, что хотите удалить серию?
                        </DialogContent>
                        <DialogActions>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                onClick={() => setDeleteSeriesDialog(false)}
                                style={{ backgroundColor: "transparent", border: "1px solid #FFC107", boxShadow: "none" }}
                            >
                                {t("Cancel")}
                            </ActionButton>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                disabled={disableRequest}
                                onClick={deleteSeries}
                                style={{ boxShadow: "none" }}
                            >
                                {t("Delete")}
                            </ActionButton>
                        </DialogActions>
                    </div>
                </Dialog>

                <Dialog open={stopSeriesDialog} onClose={() => setStopSeriesDialog(false)}>
                    <div className={classes.dialogContainer}>
                        <DialogTitle>Остановить серию</DialogTitle>
                        <DialogContent>
                            Вы уверены, что хотите остановить серию?
                        </DialogContent>
                        <DialogActions>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                onClick={() => setStopSeriesDialog(false)}
                                style={{ backgroundColor: "transparent", border: "1px solid #FFC107", boxShadow: "none" }}
                            >
                                {t("Cancel")}
                            </ActionButton>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                disabled={disableRequest}
                                onClick={stopSeries}
                                style={{ boxShadow: "none" }}
                            >
                                {t("Stop series")}
                            </ActionButton>
                        </DialogActions>
                    </div>
                </Dialog>
                <Dialog open={alarmMessage} onClose={() => setAlarmMessage(false)}>
                    <div className={classes.dialogContainer}>
                        <DialogTitle>Внимание</DialogTitle>
                        <DialogContent>
                            Отправка сообщений по этой серии начнётся с завтрашнего дня
                        </DialogContent>
                        <div className={classes.emptyLineDialog}></div>
                        <DialogActions>
                            <ActionButton
                                fullWidth={false}
                                noMargin
                                onClick={() => setAlarmMessage(false)}
                                style={{ boxShadow: "none", marginRight: "16px" }}
                            >
                                {t("Ok")}
                            </ActionButton>
                        </DialogActions>
                    </div>
                </Dialog>
            </Content>
        </>
    );
};

export default EditSerialPage;
